/**
 * Utility functions for D&AR case status validation
 */

export const CLOSED_CASE_EXACT_ERROR = "Closed cases cannot be suspended.";

export const CLOSED_STAGE_VALUES = [
  "CLOSED",
  "CLOSED STAGE",
  "CASE_CLOSED",
  "CASE CLOSED",
  "APPEAL CLOSED",
  "APPEAL_CLOSED"
];

/**
 * Checks if a given status string or case object represents a Closed stage case.
 */
export const isClosedStage = (statusOrCaseObj: any): boolean => {
  if (!statusOrCaseObj) return false;

  if (typeof statusOrCaseObj === "string") {
    const s = statusOrCaseObj.trim().toUpperCase();
    return CLOSED_STAGE_VALUES.some(closedVal => s === closedVal || s.includes("CLOSED"));
  }

  if (typeof statusOrCaseObj === "object") {
    const status = String(
      statusOrCaseObj.status ||
      statusOrCaseObj.stage ||
      statusOrCaseObj.case_status ||
      statusOrCaseObj.casetype ||
      ''
    ).trim().toUpperCase();

    if (CLOSED_STAGE_VALUES.some(closedVal => status === closedVal || status.includes("CLOSED"))) {
      return true;
    }
    if (statusOrCaseObj.is_closed === true || statusOrCaseObj.isClosed === true) {
      return true;
    }
  }

  return false;
};
